<template>
  <article class="search" v-if="keyword">
    <tab
      class="search-tab"
      :list="tabList"
      :current="tab"
      itemWidth="114"
      @item-click="handleTabClick"
    ></tab>
    <div class="search-result-count">共{{ listData.total }}条搜索结果</div>
    <template v-if="tab !== 'article'">
      <SearchTopcate
        :topcate="topcate"
        :topcateList="topcateList"
        class="search-topcate"
        @tocateChange="tocateChange"
      />
    </template>
    <div
      v-if="listData.data && listData.data.length > 0"
      class="search-unit-box"
    >
      <div
        class="search-unit-item"
        v-for="(item, index) in listData.data"
        :key="item.id"
      >
        <template v-if="item.post_type === postType.course.toString()">
          <CourseUnit
            :courseData="item"
            :keyword="keyword"
            @click.native="handleItemClick(item, index)"
          />
        </template>
        <template
          v-if="
            item.post_type === postType.article.toString() ||
            item.post_type === postType.question.toString()
          "
        >
          <Article
            :aricleData="item"
            :keyword="keyword"
            @click.native="handleItemClick(item, index)"
          />
        </template>
      </div>
      <pagination
        style="margin-top: 40px"
        :page="page"
        :size="size"
        :total="listData.total"
        @change="handlePageChange"
      ></pagination>
      <search-not-found
        class="search-course-feedback"
        :keyword="keyword"
        :fromChannel="2"
        @click.native="handleNotFound"
      ></search-not-found>
    </div>
    <search-empty
      v-if="!listData.total"
      :keyword="keyword"
      :fromChannel="1"
    ></search-empty>
  </article>
</template>

<script>
import Tab from '@/components/page-tab';
import {
  POST_TYPE,
  ITEM_TYPE_REPORT,
  ITEM_TYPE_TO_SORT,
} from '@/common/constant';
import { search2Query, query2Search, locateToQueryUrl } from '@/common/utils';

import SearchNotFound from '@/pages/search/components/search-not-found';
import SearchEmpty from '@/pages/search/components/search-empty';
import SearchTopcate from '@/pages/search/components/search-topcate';
import CourseUnit from '@/components/serach-unit/course';
import Article from '@/components/serach-unit/article';

import mixinAsyncData from '@/common/mixin/mixin-async-data';

const tabReportMap = {
  '': 'comprehensive',
  ...ITEM_TYPE_REPORT,
};

async function asyncData({ app, params, query, store }) {
  let keyword = params.keyword || query.keyword || '';
  const page = query.page ? +query.page : 1;
  const { tab = '' } = params;
  let { topcate = '' } = query;
  topcate = decodeURIComponent(topcate);
  const SIZE = 10;

  // 设置全局的搜索
  store.commit('common/setKeyword', keyword);

  // 请求相关的数据
  const genDefaultData = () => ({ total: 0, data: [] });
  // 初始化默认data防止报错
  let data = genDefaultData();
  // topcate默认是全部，因此不传
  let requsetParams = {
    from: (page - 1) * SIZE,
    size: SIZE,
    keyword,
  };

  // 综合情况下搜索三种数据
  if (tab === '') {
    requsetParams.postType = [
      POST_TYPE.course,
      POST_TYPE.article,
      POST_TYPE.question,
    ];
  } else {
    requsetParams.postType = [POST_TYPE[tab]];
  }

  if (topcate && topcate !== '') {
    requsetParams.topCate = topcate.split(',');
  }

  const res = await app.$service.ksord
    .getAcademyResources({ ...requsetParams })
    .catch(() => null);
  const resData = res ? res : data;

  // 搜索接口限制爬虫机制， 当搜索条件大于1000时，会重新返回前面搜索的内容，如page=2 等于 page=102，因此前端需要屏蔽1000条以后的内容避免重复
  if (resData.total > 1000) {
    resData.total = 1000;
  }

  return {
    tab,
    keyword,
    page,
    listData: resData,
    size: SIZE,
    topcate,
    isReady: true,
  };
}

export default {
  head() {
    let header = this.$head.defaultHead();

    const keyword = this.$store.state.common.keyword;
    if (keyword) {
      header = this.$head.searchHead(keyword);
    }
    return header;
  },
  components: {
    Tab,
    SearchTopcate,
    CourseUnit,
    Article,
    SearchNotFound,
    SearchEmpty,
  },

  computed: {
    tabList() {
      let { keyword } = this;
      keyword = encodeURIComponent(keyword);
      return [
        {
          name: '综合',
          value: '',
          to: `/search/index/keyword/${keyword}.html`,
        },
        {
          name: '视频',
          value: 'course',
          to: `/search/show/tab/course/keyword/${keyword}.html`,
        },
        {
          name: '问答',
          value: 'question',
          to: `/search/show/tab/question/keyword/${keyword}.html`,
        },
        {
          name: '文章',
          value: 'article',
          to: `/search/show/tab/article/keyword/${keyword}.html`,
        },
      ];
    },
  },

  watch: {
    isReady(val) {
      if (!val) {
        return;
      }
      this.collectShow();
    },
  },

  data() {
    return {
      tab: '',
      keyword: '',
      page: 1,
      listData: [],
      postType: POST_TYPE,
      isReady: false,
      topcateList: [
        { name: '全部', value: '' },
        { name: '文字', value: 'doc' },
        { name: '表格', value: 'xls' },
        { name: '演示', value: 'ppt' },
        { name: 'pdf', value: 'pdf' },
        { name: '其他', value: 'wps,vip,docer' },
      ],
    };
  },

  mixins: [mixinAsyncData(asyncData)],

  methods: {
    handleItemClick(item, index) {
      let form = this.topcate;
      form === '' && (form = 'all');
      form === 'wps,vip,docer' && (form = 'other');
      let sort = ITEM_TYPE_TO_SORT[item.post_type];
      this.$collect.searchpageResultClick({
        click: 'content',
        sort,
        type: item.id,
        form,
        number: (this.page - 1) * 10 + index + 1,
        searchkey: this.keyword,
        policy: this.listData.policy,
      });
    },
    handleNotFound() {
      this.$collect.searchpageResultClick({
        click: 'nofind',
        searchkey: this.keyword,
        policy: this.listData.policy,
      });
    },
    tocateChange(e) {
      const { search, pathname, origin } = location;
      const query = search2Query(search);
      query.page = 1;

      if (e === '') {
        // 从其他组件 跳转 全部时清除字段
        query.topcate && delete query.topcate;
      } else {
        query.topcate = encodeURIComponent(e);
      }

      location.href = `${origin}${pathname}${query2Search(query)}`;
    },
    handlePageChange(page) {
      locateToQueryUrl({ page });
    },

    handleTabClick(value) {
      this.$collect.searchpageResultClick({
        click: tabReportMap[value],
        searchkey: this.keyword,
      });
    },
    collectShow() {
      let source;
      if (this.tab === '') {
        source = 'comprehensive';
      } else {
        source = ITEM_TYPE_REPORT[this.tab];
      }

      let form = this.topcate;
      form === '' && (form = 'all');
      form === 'wps,vip,docer' && (form = 'other');
      this.$collect.searchpageResultShow({
        result: !!this.listData.total,
        form,
        searchkey: this.keyword,
        source,
        policy: this.listData.policy,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  .search-tab {
    margin: 19px 0 20px;
  }

  &-result {
    &-count {
      font-size: 14px;
      color: #888888;
      font-weight: 400;
    }
  }

  .search-topcate {
    margin-top: 14px;
  }

  .search-unit {
    &-box {
      width: 720px;
    }

    &-item {
      width: 100%;
      padding: 20px 0px;
      box-sizing: border-box;
      border-bottom: 1px solid #e8e8e8;
    }
  }
}
</style>
